import { Grid, Stack, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { resendActivationLink } from 'wisestep-api';
import {
  Item,
  WsTypography,
  WsTypoVariants,
  WsTypoColors,
  Notification,
  WsColors,
} from 'wisestep-base';

import { AuthLayout } from '../../../components';
import verifyImage from '../../../images/content/SentMail.svg';
import { getSocialIcon } from '../../../utils/getSocialIcon';
import { openMail } from '../utils/common';

const VerifyButton = styled(Button)(() => ({
  color: WsColors.GenericRichBlack,
}));

const StyledFooter = styled(Grid)(() => ({
  position: 'relative',
  bottom: '0px',
  textAlign: 'center',
  left: 0,
  right: 0,
}));

const AccountVerify = () => {
  const [notify, setNotify] = useState(false);

  const navigate = useNavigate();

  const [email, setEmail] = useState<string>('');

  const location: any = useLocation();

  useEffect(() => {
    setEmail(location.state?.email);
  }, [location.state?.email]);

  const resendEmail = async () => {
    resendActivationLink(email).then(() => {
      setNotify(true);
    });
  };

  return (
    <AuthLayout>
      <Item>
        <Stack direction="column" alignItems="center">
          <img src={verifyImage} alt="Verify" />
        </Stack>
        <Stack direction="column" mt={2} spacing={1} alignItems="center">
          <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.TERTIARY}>
            A verification email has been sent to
          </WsTypography>
          <WsTypography variant={WsTypoVariants.SUB_TITLE}>{email}</WsTypography>
          <Item>
            <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.QUATERNARY}>
              Click on the link sent in the email. If you have not received the email after a few
              minutes, please check your spam folder.
            </WsTypography>
          </Item>
        </Stack>
        <Grid mt={1} container justifyContent="center" alignItems="center">
          <Grid item>
            <Item>
              <VerifyButton
                startIcon={getSocialIcon('Gmail')}
                onClick={() => openMail('Gmail')}
                variant="outlined"
                size="large"
              >
                Open Gmail
              </VerifyButton>
            </Item>
          </Grid>
          <Grid item>
            <Item>
              <VerifyButton
                startIcon={getSocialIcon('Outlook')}
                onClick={() => openMail('Outlook')}
                variant="outlined"
                size="large"
              >
                Open Outlook
              </VerifyButton>
            </Item>
          </Grid>
        </Grid>
        <StyledFooter>
          <Stack mt={4} justifyContent="center" direction="row" alignItems="center" spacing={1}>
            <WsTypography color={WsTypoColors.TERTIARY} variant={WsTypoVariants.BODY1}>
              Still can’t find the email ?
            </WsTypography>
            <WsTypography
              cursor="pointer"
              onClick={resendEmail}
              color={WsTypoColors.PRIMARY}
              variant={WsTypoVariants.BODY1}
            >
              Resend Email
            </WsTypography>
          </Stack>
          <Stack justifyContent="center" direction="row" mt={2} alignItems="center" spacing={1}>
            <WsTypography color={WsTypoColors.TERTIARY} variant={WsTypoVariants.BODY1}>
              Already Verified ?
            </WsTypography>
            <WsTypography
              cursor="pointer"
              onClick={() => navigate('/')}
              color={WsTypoColors.PRIMARY}
              variant={WsTypoVariants.BODY1}
            >
              Login Here
            </WsTypography>
          </Stack>
        </StyledFooter>
        <Notification
          vertical="top"
          horizontal="center"
          autoHideDuration={6000}
          notify={notify}
          notificationObject={{ message: 'Email Resent', type: 'success' }}
        />
      </Item>
    </AuthLayout>
  );
};
export default AccountVerify;
